import { Loader } from "@mantine/core";

export const CustomLoader = () => {
  return <Loader color={"white"} size={"sm"} />;
};

export const CustomLoaderSmall = () => {
  return <Loader ml="xs" color={"white"} size={"xs"} />;
};
